module.exports = __webpack_public_path__ + "img/34.be5b067f.jpg";